<template>
  <div class="finishing-options-page">
    <div class="container">
      <h1 class="page-title">Sheet Metal Surface Finishes</h1>

      <div class="table-wrapper">
        <table class="finishing-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Finishing</th>
              <th>Description</th>
              <th>Application</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in finishingList" :key="index">
              <td>
                <img :src="item.image" alt="" class="process-img" />
              </td>
              <td class="process-link">{{ item.name }}</td>
              <td>
                <div>
                  <span class="process-link">Description: </span>
                  {{ item.desc }}
                </div>
                <br v-if="item.roughness" />
                <span v-if="item.roughness" class="process-link">Surface Roughness: </span>
                <span v-if="item.roughness">{{ item.roughness }}</span>
              </td>
              <td>{{ item.application }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="note-bar">
        <p class="note-text">
          *For Surface Finishes not listed here, <span @click="$router.push('/contact')" class="contact-link">please contact us directly.</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sheet_FinishingOptions',
  data() {
    return {
      // 所有表面处理数据统一放在这里
finishingList: [
  {
    name: 'Sand Blasting',
    image: require('@/assets/ma/sheet/1.png'),
    desc: 'Abrasive media is blasted onto the surface to remove oxidation, tool marks, burrs, and impurities while creating a uniform matte texture.',
    application: 'Sheet metal enclosures, brackets, stainless steel panels, aluminum housings, and welded assemblies requiring surface preparation or matte appearance.'
  },
  {
    name: 'Brushed Finish',
    image: require('@/assets/ma/sheet/2.png'),
    desc: 'Mechanical surface treatment that creates fine, unidirectional lines on the material surface, producing a satin-like decorative appearance.',
    roughness: 'Ra 0.4-2.5 µm, depending on the brush type and material.',
    application: 'Stainless steel appliance panels, decorative covers, elevator panels, kitchen equipment, and consumer electronics housings.'
  },
  {
    name: 'Polishing',
    image: require('@/assets/ma/sheet/3.png'),
    desc: 'Mechanical polishing process that smooths the surface to a bright, reflective, or mirror-like finish while reducing scratches and imperfections.',
    application: 'Decorative metal panels, mirror-finish stainless steel parts, architectural trim, medical equipment covers, and luxury hardware.'
  },
  {
    name: 'Passivation',
  image: require('@/assets/ma/sheet/4.png'),
    desc: 'Chemical treatment that removes free iron and surface contaminants to improve corrosion resistance without significantly affecting dimensions or appearance.',
    application: 'Stainless steel sheet metal parts, medical equipment, food processing equipment, marine hardware, and corrosion-resistant enclosures.'
  },
  {
    name: 'Alodine / Chem Film',
    image: require('@/assets/ma/sheet/5.png'),
    desc: 'Chemical conversion coating that provides corrosion protection while maintaining electrical conductivity and improving paint adhesion.',
    application: 'Aerospace sheet metal components, electronic enclosures, communication cabinets, EMI/RFI shielding housings, and aluminum assemblies.'
  },
  {
    name: 'Anodizing',
    image: require('@/assets/ma/sheet/6.png'),
    desc: 'Electrochemical process that forms a durable oxide layer on aluminum surfaces to improve corrosion resistance, wear resistance, and appearance.',
    application: 'Aluminum control panels, electronic housings, architectural panels, consumer electronics enclosures, and decorative aluminum sheet metal parts.'
  },
  {
    name: 'Powder Coating',
     image: require('@/assets/ma/sheet/7.png'),
    desc: 'Electrostatic dry powder coating cured under heat to create a durable, corrosion-resistant, and decorative finish.',
    application: 'Outdoor cabinets, electrical enclosures, automotive brackets, industrial equipment housings, and architectural sheet metal structures.'
  },
  {
    name: 'Painting',
    image: require('@/assets/ma/sheet/8.png'),
    desc: 'Spray or liquid paint coating applied for decorative appearance, branding colors, and environmental protection.',
    application: 'Equipment housings, machinery covers, control cabinets, display panels, and general industrial sheet metal parts.'
  },
  {
    name: 'Electrophoresis (E-Coating)',
    image: require('@/assets/ma/sheet/9.png'),
    desc: 'Coating process using electrically charged paint particles to achieve highly uniform coverage and enhanced corrosion resistance.',
    application: 'Automotive sheet metal components, chassis parts, brackets, industrial housings, and metal frames requiring uniform coating coverage.'
  },
  {
    name: 'Electroplating',
     image: require('@/assets/ma/sheet/10.png'),
    desc: 'Electrochemical process that deposits a thin metal layer such as nickel, zinc, or chrome onto the surface for corrosion resistance or decorative purposes.',
    application: 'Sheet metal brackets, fasteners, electrical components, decorative hardware, and corrosion-resistant industrial parts.'
  },
  {
    name: 'Black Oxide',
   image: require('@/assets/ma/sheet/11.png'),
    desc: 'Chemical conversion coating that creates a dark protective surface on steel and iron parts while improving mild corrosion resistance.',
    application: 'Steel brackets, industrial fixtures, fasteners, tooling components, and black-finish metal hardware.'
  },
  {
    name: 'Silkscreen',
    image: require('@/assets/ma/sheet/12.png'),
    desc: 'Printing process using mesh screens and ink to apply logos, labels, symbols, or operating instructions onto surfaces.',
    application: 'Control panels, electrical cabinets, equipment housings, front panels, warning labels, and branded sheet metal products.'
  },
  {
    name: 'Laser Marking',
    image: require('@/assets/ma/sheet/13.png'),
    desc: 'High-precision laser process used to permanently engrave serial numbers, QR codes, logos, and traceability markings onto surfaces.',
    application: 'Industrial nameplates, electrical enclosures, stainless steel panels, medical equipment housings, and traceability-marked sheet metal components.'
  }
]
    }
  }
}
</script>

<style scoped>
.finishing-options-page {
  padding: 40px 20px;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.container {
  /* 使用 max-width 让容器能随屏幕缩小 */
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.page-title {
  /* 响应式标题：手机上小，电脑上大 */
  font-size: clamp(24px, 4vw, 32px);
  color: #333333;
  text-align: center;
  margin: 0 0 30px;
  font-weight: 600;
}

/* 表格外层包裹器 */
.table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto; /* 允许横向滑动 */
  -webkit-overflow-scrolling: touch; /* 让 iOS 设备上滑动更顺滑 */
  border: 1px solid #f0ecec; 
  border-radius: 8px;
}

.finishing-table {
  width: 100%;
  /* 设定最小宽度，当屏幕小于800px时，出现横向滚动条 */
  min-width: 800px; 
  border-collapse: collapse;
  background-color: #ffffff;
}

.finishing-table thead tr {
  background-color: #f0f4f5;
}

.finishing-table th,
.finishing-table td {
  padding: 18px 15px;
  text-align: left;
  color: #666666;
  font-size: 16px;
  line-height: 1.6;
}

.finishing-table th {
  font-weight: 600;
  color: #333333;
  text-align: left; /* 表头文字左对齐更利于阅读长表格 */
}

.finishing-table tbody tr {
  border-top: 1px solid #f0ecec;
}

/* 去除首行边框，因为外层 wrapper 已经有了 */
.finishing-table tbody tr:first-child {
  border-top: none; 
}

/* 列宽分配优化 */
.finishing-table td:nth-child(1),
.finishing-table th:nth-child(1) {
  width: 100px;
  padding: 12px;
}

.finishing-table td:nth-child(2),
.finishing-table th:nth-child(2) {
  width: 160px;
}

.finishing-table td:nth-child(3),
.finishing-table th:nth-child(3) {
  width: 50%;
}

.finishing-table td:nth-child(4),
.finishing-table th:nth-child(4) {
  width: 25%;
}

.process-img {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.process-link {
  font-weight: 500;
}

.note-bar{
  width: 100%;
}

.note-text {
  margin: 0;
  font-size: 15px;
  color: #666666;
  line-height: 1.6;
}

.contact-link {
  color: #16bc9c;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}

.contact-link:hover {
  text-decoration: underline;
}

/* 移动端响应式调整 */
@media (max-width: 768px) {
  .finishing-options-page {
    padding: 30px 15px;
  }
  
  .finishing-table th,
  .finishing-table td {
    padding: 12px 10px;
    font-size: 14px;
  }
  
  .process-img {
    width: 60px;
    height: 45px;
  }
  
  .note-text {
    font-size: 14px;
  }
}
</style>